export function getAuthTokenFromLocalStorage() {
  return localStorage.getItem("token");
}
